import { useSnackbar } from 'notistack';
import { requestMediaUrl } from '../utils/requestMediaUrl';

function usePreviewFile(url: string): () => void {
    const { enqueueSnackbar } = useSnackbar();

    const previewFile = async () => {
        try {
            await requestMediaUrl(url, (mediaUrl) => window.open(mediaUrl, '_blank', 'noopener'));
        } catch (e) {
            enqueueSnackbar('Could not preview file', { variant: 'error' });
        }
    };

    return previewFile;
}

export default usePreviewFile;
